import { useState } from 'react';
import axios from 'axios';
import { useGoogleLogin } from '@react-oauth/google';
import { API_BASE_URL, SESSION_KEY } from '../constants';
import { saveSession } from '../utils/auth';
import '../styles/GoogleLoginButton.css';

// Our own themed button. It opens Google's sign-in pop-up; the backend checks
// the token with Google before signing the customer in.
const GoogleLoginButton = ({ onLogin, onError, label = 'Continue with Google' }) => {
    const [busy, setBusy] = useState(false);

    const fail = (message) => {
        setBusy(false);
        if (onError) onError(message || 'Google login failed. Try again.');
    };

    const login = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                // the session key lets the backend attach this browser's guest
                // addresses and orders to the account
                const res = await axios.post(`${API_BASE_URL}/google-login/`, {
                    access_token: tokenResponse.access_token,
                }, SESSION_KEY);
                saveSession(res.data);
                setBusy(false);
                if (onLogin) onLogin(res.data.user);
            } catch (err) {
                console.log('Google login failed', err);
                fail(err.response?.data?.error);
            }
        },
        onError: () => fail(),
        // closing the pop-up is not an error worth showing
        onNonOAuthError: () => setBusy(false),
    });

    return (
        <button
            type="button"
            className="google-login-btn"
            onClick={() => {
                setBusy(true);
                login();
            }}
            disabled={busy}
        >
            <span className="google-login-icon" aria-hidden="true">
                <svg viewBox="0 0 48 48" width="18" height="18">
                    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
                    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
                    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
                    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
                </svg>
            </span>
            <span>{busy ? 'Signing in...' : label}</span>
        </button>
    );
};

export default GoogleLoginButton;
